import type { Payment } from "../../types/payment.types";

type GetValueFromTrialTypeProps<ValueType extends number | string> = {
  trialType: Payment["trialType"];
  values: Record<Exclude<Payment["trialType"], null>, ValueType | null> & {
    default: ValueType;
  };
};

export const getValueFromTrialType = <ValueType extends number | string>({
  trialType,
  values,
}: GetValueFromTrialTypeProps<ValueType>) => {
  if (trialType === "free") return values.free;
  if (trialType === "paid") return values.paid;

  return values.default;
};
